import { useCookies } from "react-cookie"

const useLoginCookie = () => {

    const cookieName = "LC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (token) => {
        setCookie(cookieName, token, {
            "path": "/",
            "sameSite": "none",
            "secure": true,
            "expires": new Date(Date.now() + 1000 * 3600 * 24 * 30)
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useLoginCookie